<template>
  <div :class="$style.wrap">
    <IconList :class="$style.icon" />

    <MarkedParser :md="data?.fields?.copy" :class="$style.copy" />

    <CallToAction
      v-if="data?.fields?.cta"
      :class="$style.cta"
      :cta="data?.fields?.cta"
    />

    <em v-if="data?.fields?.footnote" :class="$style.footnote">
      {{ data?.fields?.footnote }}
    </em>
  </div>
</template>

<script setup lang="ts">
import type { TypeAsideCardWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeAsideCardWithoutUnresolvableLinksResponse
}>()
</script>

<style lang="scss" module>
.wrap {
  padding: 37px 30px 24px;
}

.icon {
  width: 58px;
  height: 48px;
  color: #828282;
}

.copy {
  font-size: to-rem(17px);
  font-weight: 600;
  line-height: math.div(25, 17);
  margin-top: 17px;
}

.cta {
  margin-top: 28px;
}

.footnote {
  display: block;
  font-size: to-rem(14px);
  line-height: math.div(20, 14);
  margin-top: 50px;
  padding-top: 12px;
  border-top: 1px solid rgba(#fff, 0.25);
}
</style>
